import { render, staticRenderFns } from "./widgetFwGeoDenyTrafficTopn.vue?vue&type=template&id=ccc9447a&scoped=true&"
import script from "./widgetFwGeoDenyTrafficTopn.vue?vue&type=script&lang=js&"
export * from "./widgetFwGeoDenyTrafficTopn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc9447a",
  null
  
)

export default component.exports